import React from 'react';
import { styled } from '@mui/material/styles';
import MuiCard from '@mui/material/Card';

// Define the StyledCard component with dynamic topMargin and width
const StyledCard = styled(MuiCard, {
  shouldForwardProp: (prop) => prop !== 'topMargin' && prop !== 'width',
})(({ theme, width, topMargin }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignSelf: 'center',
  width: width || '100%', // Use dynamic width or default to 100%
  padding: theme.spacing(4),
  gap: theme.spacing(2),
  boxShadow:
    'hsla(220, 30%, 5%, 0.05) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.05) 0px 15px 35px -5px',
  marginTop: topMargin || theme.spacing(4), // Default to 16px (theme.spacing(4)) if topMargin is not provided
  [theme.breakpoints.up('sm')]: {
    width: width || '450px', // Default to 450px if width is not provided
  },
  ...theme.applyStyles('dark', {
    boxShadow:
      'hsla(220, 30%, 5%, 0.5) 0px 5px 15px 0px, hsla(220, 25%, 10%, 0.08) 0px 15px 35px -5px',
  }),
}));

// CustomCard component that accepts width and topMargin props
const CustomCard = ({ children, width, topMargin }) => {
  return (
    <StyledCard variant="outlined" width={width} topMargin={topMargin}>
      {children}
    </StyledCard>
  );
};

export default CustomCard;
